<template>
    <!--我的订单-->
  <div id="myorder">
    <person-head :title="title"></person-head>
    <div class="order" v-for="(item, index) in orderData" :key="index">
      <h3 :title="item.shop_id">
        订单编号：{{item.numbers}}
        <a :href="item.address_href" class="copy" v-if="item.address_content">查看物流</a>
        <a class="copy" v-if="item.shop_status === 0">等待付款</a>
      </h3>
      <div class="main">
        <div class="left">
          <img :src="item.app_img_1">
        </div>
        <div class="right">
          <h4>{{item.shop_name}}</h4>
          <div class="b">
            ¥<b>{{item.pay_amount}}</b>{{item.pay_amount_decimal}}
          </div>
        </div>
      </div>
      <div class="cc">
        <router-link :to="{name: 'OrderRepay', query: {shop_id: item.shop_id}}" v-if="item.shop_status === 0">去支付</router-link>
        <router-link :to="{name: 'MyClass'}" class="gotostudy" v-else-if="item.shop_status === 1">去学习</router-link>
        <a class="gray" v-else-if="item.shop_status === 2">申请退款中</a>
        <a class="gray" v-else-if="item.shop_status === 3">已退款</a>
        <a class="gray" v-else-if="item.shop_status === 5 || item.shop_status === 6">已取消</a>
        <a class="gray" v-else-if="item.shop_status === 7">退款中</a>
        <a class="gray" v-else-if="item.shop_status === 8">已发货</a>
        <a class="gray" v-else-if="item.shop_status === 9">拒绝退款</a>
        <a class="gray" v-else-if="item.shop_status === 10">已签收</a>
        <a class="gray" v-else-if="item.shop_status === 11">拒绝签收</a>
        <a class="gray" v-else-if="item.shop_status === 12">已退货</a>
        <router-link :to="{name: 'MyCoupon'}" class="gotostudy" v-else-if="item.shop_status === 13">去使用</router-link>
      </div>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
import personHead from '../share/header/personHead'
export default {
  name: 'MyOrder',
  data () {
    return {
      orderData: {},
      title: '我的订单'
    }
  },
  components: {
    personHead
  },
  methods: {
    getOrder () {
      let data = {
        page: 1,
        length: 100
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_all_order',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.orderData = res.data.data.info
          } else if (res.data.errcode === -1 || res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'MyOrder'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.getOrder()
  }
}
</script>

<style scoped lang="stylus">
#myorder
  .order
    width: 7.1rem
    background-color: #fff
    padding: .32rem .24rem 0
    margin: .2rem auto 0
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    &:nth-of-type(1)
      margin-top: 0
    h3
      position: relative
      font-size: .28rem
      color: #333
      font-weight: 600
      a.copy
        position: absolute
        top: -.03rem
        right: 0
        display: inline-block
        width: 1.5rem
        height: .46rem
        line-height: .46rem
        font-size: .22rem
        color: #FF7052
        font-weight: 500
        text-align: center
    .main
      display: flex
      justify-content: space-between
      align-items: center
      margin-top: .32rem
      .left
        width: 2rem
        height: 2rem
        overflow: hidden
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
        img
          width: 100%
          height: 100%
      .right
        position: relative
        display: flex
        justify-content: space-between
        align-items: center
        width: 4.36rem
        height: 2rem
        h4
          width: 3.2rem
          margin-bottom: .05rem
          font-size: .3rem
          color: #161616
          font-weight: 400
        div.b
          width: 1.5rem
          font-size: .22rem
          color: #161616
          text-align: right
          b
            font-size: .3rem
    .cc
      display: flex
      justify-content: flex-end
      align-items: center
      height: 1.58rem
      a
        display: block
        width: 1.52rem
        height: .6rem
        line-height: .6rem
        border: .02rem solid #FF7052
        font-size: .26rem
        color: #FF7052
        text-align: center
        -webkit-border-radius: .3rem
        -moz-border-radius: .3rem
        border-radius: .3rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.gotostudy
          background-color: #FF7052
          color: #fff
        &.gray
          border-color: #ccc
          color: #ccc
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/MyOrder.vue